$(function() {

var REGEXP_SUFFIX = /^(?:width|height|left|top|marginLeft|marginTop)$/;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
function isObject(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null;
  }
function isFunction(value) {
    return typeof value === 'function';
  }
function forEach(data, callback) {
    if (data && isFunction(callback)) {
      if (Array.isArray(data) || isNumber(data.length) /* array-like */) {
          var length = data.length;

          var i = void 0;

          for (i = 0; i < length; i += 1) {
            if (callback.call(data, data[i], i, data) === false) {
              break;
            }
          }
        } else if (isObject(data)) {
        Object.keys(data).forEach(function (key) {
          callback.call(data, data[key], key, data);
        });
      }
    }

    return data;
  }
function setStyle(element, styles) {
    var style = element.style;


    forEach(styles, function (value, property) {
      if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
        value += 'px';
      }

      style[property] = value;
    });
  }
function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }
function removeClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        removeClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.remove(value);
      return;
    }

    if (element.className.indexOf(value) >= 0) {
      element.className = element.className.replace(value, '');
    }
  }
function addClass(element, value) {
    if (!value) {
      return;
    }

    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        addClass(elem, value);
      });
      return;
    }

    if (element.classList) {
      element.classList.add(value);
      return;
    }

    var className = element.className.trim();

    if (!className) {
      element.className = value;
    } else if (className.indexOf(value) < 0) {
      element.className = className + ' ' + value;
    }
  }
$.fn.cropper.Constructor.prototype.initContainer = function () {
    var element = this.element,
        options = this.options,
        container = this.container,
        cropper = this.cropper;

    console.log('this')
    console.log(this)
    console.log(this.parent)
    
    addClass(cropper, '-hidden');
    removeClass(element, '-hidden');
   
    console.log(options)
    var containerData = {
      width: Math.max(element.offsetWidth, Number(options.minContainerWidth) || 200),
      height: Math.max(element.offsetHeight, Number(options.minContainerHeight) || 100)
    };
    console.log('containerData')
    console.log(containerData)
    this.containerData = containerData;

    setStyle(cropper, {
      width: containerData.width,
      height: containerData.height
    });

    addClass(element, '-hidden');
    removeClass(cropper, '-hidden');
  }
});